export default __webpack_public_path__ + "assets/Venmo-a4d162e6e26729c2ee833d37c77675da.svg";